export function replacePlaceholdersWithRegex(
  str: string,
  replacements: Record<string, any>
) {
  return str.replace(/\{(\w+)\}/g, (match, key) => {
    return replacements[key] || match;
  });
}
